import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Star, Moon, Planet } from 'phosphor-react';

/**
 * Bottom Navigation
 * Based on Figma design with Phosphor icons
 * Labels: "Daily Affirm", "Set Intent", "Blueprint"
 * Active state: Orange Primary (#FE5706)
 * Inactive state: Grey (#999999)
 */
export const BottomNavigation: React.FC = () => {
  const location = useLocation();

  const tabs = [
    { path: '/affirm', label: 'Daily Affirm', icon: Star },
    { path: '/journey', label: 'Set Intent', icon: Moon },
    { path: '/blueprint', label: 'Blueprint', icon: Planet },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-black border-t border-white-p40 h-[86px] flex items-start justify-around z-50 pt-1 pb-10">
      {tabs.map((tab) => {
        const active = isActive(tab.path);
        const IconComponent = tab.icon;
        return (
          <Link
            key={tab.path}
            to={tab.path}
            className="flex flex-col items-center justify-start min-h-[44px] min-w-[44px] px-4 transition-colors duration-200 relative"
            aria-label={`Navigate to ${tab.label}`}
          >
            <IconComponent
              size={24}
              weight={active ? 'fill' : 'regular'}
              className={`transition-colors duration-200 ${
                active ? 'text-orange-primary' : 'text-white-p60'
              }`}
            />
            <span
              className={`text-xs font-primary transition-colors duration-200 mt-[6px] ${
                active ? 'text-orange-primary' : 'text-white-p60'
              }`}
              style={{
                fontFamily: 'Space Grotesk',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '14.4px',
              }}
            >
              {tab.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
};

export default BottomNavigation;
